export const blockIconsHouseholdBackHandNew = (
	<span className='material-symbols-outlined'>back_hand</span>
);
